import styles from "./Input_search.module.scss";

import { useState } from "react";

import React from "react";
import { Input } from "../Input";

export interface InputSearchProps {
  type?: "text" | "number";
  text?: string;
  value?: any;
  readOnly?: boolean;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  valueChange?: (valor: any) => void;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
  handleClick?: (event: any) => void;
  onKeyUp?: (e: any) => void;
  isErrored?: boolean
}

export const TEST_ID = 'input-search-testid';

export const InputSearch: React.FC<InputSearchProps> = ({
  handleClick,
  type,
  text,
  value,
  readOnly,
  className,
  placeholder,
  disabled,
  valueChange,
  onBlur,
  onFocus,
  onKeyUp,
  isErrored,
}) => {
  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyPress = (event, valueChange) => {
    if (event.key === "Enter") {
      window.location.href = "https://www.superbid.net/busca/" + valueChange;
    }
  };
  const handleOnClick = (valueChange) => {
    window.location.href = "https://www.superbid.net/busca/" + valueChange;
  };
  const OnChange = (value: string) => {
    if (value) {
      setSearch(value);
    }
  };


  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  return (
    <div data-testid={TEST_ID} className={`${styles.box} ${className}`}>
      <div className={`
      ${styles.inputGroup} 
      ${className} 
      ${isFocused && styles.inputGroup__inputBox__focused} 
      ${isErrored && styles.inputGroup__inputBox__errored}`}>

        <div className={`${styles.inputGroup__inputBox}`}>
          <input
            type={type ?? "text"}
            value={value}
            id="input"
            readOnly={readOnly}
            placeholder={placeholder}
            onChange={(e) => OnChange(e.target.value)}
            onBlur={(e) => {
              onBlur?.(e.target.value)
              handleBlur()
            }}
            onFocus={(e) => {
                onFocus?.(e.target.value)
                handleFocus();
              }
            }
            
            onKeyUp={(e) => onKeyUp?.(e)}
            className={`${styles.input} ${isErrored && styles.input__errored} ${onFocus ? "" : ".input:focus"}`}
          />
        </div>
      </div>
      <button onClick={() => handleOnClick(search)} className={styles.button}>
        <svg
          className={styles.icon}
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
        </svg>
      </button>
    </div>
  );
};
